import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-dropdown-right",
  "use": "icon-icon-dropdown-right-usage",
  "viewBox": "0 0 5.579 9.299",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 5.579 9.299\" id=\"icon-icon-dropdown-right\">\n  <path id=\"icon-icon-dropdown-right_Path_854\" data-name=\"Path 854\" d=\"M.6,0,0,.563,4.373,4.649,0,8.737.6,9.3,5.579,4.649Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol